export default {
  sorry: 'Sorry',
  sorryClass: 'Sorry, we konden geen tarieven vinden in de ',
  weFound: 'we hebben ',
  noResults: 'geen resultaten',
  fares: ' fares',
  theseDates: ' gevonden voor deze data.',
  matchingSearch: 'die voldoen aan uw zoekopdracht.',
}
